import {
  u
} from "./chunk--chunk-Y4CODN35.vbt.js";
import {
  Client,
  Logger,
  Tracker
} from "./chunk--chunk-TIBSNGGV.vbt.js";
import {
  AppMode,
  DomTargeter,
  getContext,
  require_cjs
} from "./chunk--chunk-4ICRLO2T.vbt.js";
import "./chunk--chunk-LTTGNGT7.vbt.js";
import {
  E,
  init_preact_module
} from "./chunk--chunk-WOOXM6XY.vbt.js";
import {
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// node_modules/@searchspring/snap-preact/dist/esm/Instantiators/RecommendationInstantiator.js
init_preact_module();
var import_deepmerge = __toESM(require_cjs());
var RecommendationInstantiator = class {
  constructor(config, services, context) {
    this.mode = AppMode.production;
    this.controller = {};
    this.uses = [];
    this.plugins = [];
    this.middleware = [];
    this.config = config;
    if (!this.config) {
      throw new Error(`Recommendation Instantiator config is required`);
    }
    if (!this.config.config?.branch) {
      throw new Error(`Recommendation Instantiator config must contain 'branch' property`);
    }
    if (!this.config.components || typeof this.config.components != "object" || !Object.keys(this.config.components).length) {
      throw new Error(`Recommendation Instantiator config must contain 'components' mapping property`);
    }
    if ((!services?.client || !services?.tracker) && !this.config?.client?.globals?.siteId) {
      throw new Error(`Recommendation Instantiator config must contain a valid config.client.globals.siteId value`);
    }
    if (this.config.mode && Object.values(AppMode).includes(this.config.mode)) {
      this.mode = this.config.mode;
      if (this.config?.client?.globals?.siteId) {
        this.config.client.config = this.config.client.config || {};
        this.config.client.config.mode = this.config.client.config.mode || this.mode;
      }
    }
    window.searchspring = window.searchspring || {};
    this.context = (0, import_deepmerge.default)(context || {}, config.context || {});
    this.client = services?.client || new Client(this.config.client.globals, this.config.client.config);
    this.tracker = services?.tracker || new Tracker(this.config.client.globals);
    this.logger = services?.logger || new Logger({ prefix: "RecommendationInstantiator ", mode: this.mode });
    const profileCount = {};
    this.targeter = new DomTargeter([
      {
        selector: `script[type="searchspring/recommend"], script[type="searchspring/personalized-recommendations"]${this.config.selector ? ` , ${this.config.selector}` : ""}`,
        autoRetarget: true,
        clickRetarget: true,
        inject: {
          action: "before",
          element: (target, origElement) => {
            const profile = origElement.getAttribute("profile") || "";
            const recsContainer = document.createElement("div");
            recsContainer.setAttribute("searchspring-recommend", profile);
            return recsContainer;
          }
        }
      }
    ], async (target, injectedElem, elem) => {
      const tag = injectedElem?.getAttribute("searchspring-recommend");
      if (!tag) {
        this.logger.warn(`'profile' attribute is missing from <script> tag, skipping this profile`, elem);
        return;
      }
      const contextGlobals = {};
      const elemContext = getContext(["shopperId", "shopper", "product", "seed", "cart", "options", "profile", "custom"], elem);
      const context2 = (0, import_deepmerge.default)(this.context, elemContext);
      const { shopper, shopperId, product, seed, cart, options } = context2;
      if (shopper || shopperId) {
        contextGlobals.shopper = shopper?.id || shopperId;
      }
      if (product || seed) {
        contextGlobals.product = product || seed;
      }
      if (options?.branch) {
        contextGlobals.branch = options.branch;
      }
      if (options?.siteId) {
        contextGlobals.siteId = options.siteId;
      }
      if (options?.categories) {
        contextGlobals.categories = options.categories;
      }
      if (options?.limit && Number.isInteger(Number(options?.limit))) {
        contextGlobals.limits = Number(options?.limit);
      }
      let cartContents;
      if (typeof cart === "function") {
        try {
          const cartFuncContents = cart();
          if (Array.isArray(cartFuncContents)) {
            cartContents = cartFuncContents;
          }
        } catch (e) {
          this.logger.warn(`Error getting cart contents from function`, e);
        }
      } else if (Array.isArray(cart)) {
        cartContents = cart;
      }
      if (Array.isArray(cartContents)) {
        this.tracker.cookies.cart.set(cartContents);
        contextGlobals.cart = this.tracker.cookies.cart.get();
      }
      profileCount[tag] = profileCount[tag] + 1 || 1;
      const defaultGlobals = {
        limits: 20
      };
      const globals = (0, import_deepmerge.default)((0, import_deepmerge.default)(defaultGlobals, this.config.client?.globals || {}), contextGlobals);
      const controllerConfig = {
        id: `recommend_${tag}_${profileCount[tag] - 1}`,
        tag,
        batched: options?.batched ?? true,
        realtime: Boolean(options?.realtime),
        ...this.config.config,
        globals
      };
      let controller = Object.keys(this.controller).map((id) => this.controller[id]).filter((controller2) => {
        return JSON.stringify({
          batched: controller2.config.batched,
          branch: controller2.config.branch,
          globals: controller2.config.globals,
          tag: controller2.config.tag,
          realtime: controller2.config.realtime
        }) == JSON.stringify({
          batched: controllerConfig.batched,
          branch: controllerConfig.branch,
          globals: controllerConfig.globals,
          tag: controllerConfig.tag,
          realtime: controllerConfig.realtime
        });
      })[0];
      if (!controller) {
        const createRecommendationController = (await import("./chunk--createRecommendationController-ECRC5Z7O.vbt.js")).default;
        controller = createRecommendationController({
          url: this.config.url,
          controller: controllerConfig,
          context: context2,
          mode: this.config.mode
        }, { client: this.client, tracker: this.tracker });
      }
      this.uses.forEach((attachements) => controller.use(attachements));
      this.plugins.forEach((plugin) => controller.plugin(plugin.func, ...plugin.args));
      this.middleware.forEach((middleware) => controller.on(middleware.event, ...middleware.func));
      if (!controller.store.loaded && !controller.store.loading) {
        await controller.search();
      }
      controller.addTargeter(this.targeter);
      this.controller[controller.config.id] = controller;
      window.searchspring.controller = window.searchspring.controller || {};
      window.searchspring.controller[controller.config.id] = controller;
      const profileVars = controller.store.profile.display.templateParameters;
      const component = controller.store.profile.display.template?.component;
      if (controller.store.error) {
        return;
      }
      if (!controller.store.profile.display.template) {
        this.logger.error(`profile '${tag}' found on the following element is missing a template!
${elem?.outerHTML}`);
        return;
      }
      if (!profileVars) {
        this.logger.error(`profile '${tag}' found on the following element is missing templateParameters!
${elem?.outerHTML}`);
        return;
      }
      if (!component) {
        this.logger.error(`profile '${tag}' found on the following element is missing a component!
${elem?.outerHTML}`);
        return;
      }
      const RecommendationsComponent = this.config.components[component] && await this.config.components[component]();
      if (!RecommendationsComponent) {
        this.logger.error(`profile '${tag}' found on the following element is expecting component mapping for '${component}' - verify instantiator config.
${elem?.outerHTML}`);
        return;
      }
      setTimeout(() => {
        if (injectedElem) {
          E(u(RecommendationsComponent, { controller }), injectedElem);
        }
      });
    });
  }
  plugin(func, ...args) {
    this.plugins.push({ func, args });
  }
  on(event, ...func) {
    this.middleware.push({ event, func });
  }
  use(attachments) {
    this.uses.push(attachments);
  }
};
export {
  RecommendationInstantiator
};
